import styled from "~/ui/styled"

/** H5 页面根容器，替代 Screen + ViewStyle flex:1 */
export const PageRoot = styled.div<{ $background?: string }>`
  flex: 1;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  background-color: ${({ $background, theme }) => $background ?? theme.colors.background};
`

export default PageRoot
